export default {
    props: [
        'name',
        'tariff',
    ],
};
